import { createTheme } from '@mui/material/styles';

const ifrcTheme = createTheme({
  palette: {
    primary: {
      main: '#E2001A', // IFRC Red
    },
    secondary: {
      main: '#011e4a',
    },
    error: {
      main: '#D15B5B',
    },
    warning: {
      main: '#D19C5B',
    },
    info: {
      main: '#5B9CD1',
    },
    success: {
      main: '#5BB8A7',
    },
    background: {
      default: '#F6F8FA',
      paper: '#ffffff',
    },
    text: {
      primary: '#1A364D',
      secondary: '#2C4B63',
      disabled: '#8FA0AD',
    },
  },
  typography: {
    fontFamily: 'Open Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif',
    h1: {
      fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif',
    },
    h2: {
      fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif',
    },
    h3: {
      fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif',
    },
    h4: {
      fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif',
    },
    h5: {
      fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif',
    },
    h6: {
      fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif',
    },
    subtitle1: {
      fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif',
    },
    subtitle2: {
      fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#F6F8FA',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#006D87', // IFRC secondary color
        },
      },
    },
  },
});

export default ifrcTheme; 